import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultSeasonsExportFieldNames } from "~pages/Seasons/SeasonListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportSeasons = () => {
  const { sport = "", organizationId = "", competitionId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultSeasonsExportFieldNames,
      };
      return await request(`${sport}/o/${organizationId}/competitions/${competitionId}/seasons/export`, {
        method: "POST",
        body,
      });
    },
  });
};
